import React from 'react'
import error from '../../images/errortable.gif';

const EmptyDoc = (props) => {
    return (
        <> 
        <div className="d-flex justify-content-center align-items-center  py-5 flex-column border border-radius-32 bg-white">
        <div className="w-25">
        <img src={error} alt="" className="img-fit"/>
        </div>
            <h1 className="text-base-color title-font-700 text-capitalize">{props.bargraph ? "No Data available...":props.tenant ? "No Documents Uploaded for this Tenant ... " : "No Documents available...🤷🏻‍♂️"}</h1>
        </div>
        </>
    )
}

export default EmptyDoc